import { User } from "~/shared/api/user/user.grpc";

/**
 * Получает инициалы диспетчера по его ID из Map диспетчеров
 * @param authorId - ID автора маршрута
 * @param dispatchersMap - Map диспетчеров
 * @returns Инициалы диспетчера или ID, если диспетчер не найден
 */
export const getDispatcherInitials = (
  authorId: number | undefined,
  dispatchersMap: Map<number, User> | undefined,
): string => {
  if (!authorId || !dispatchersMap) return authorId?.toString() || "—";

  const dispatcher = dispatchersMap.get(authorId);
  if (!dispatcher) return authorId.toString();

  const firstName = dispatcher.firstName || "";
  const lastName = dispatcher.lastName || "";

  const firstInitial = firstName.charAt(0).toUpperCase();
  const lastInitial = lastName.charAt(0).toUpperCase();

  return firstInitial + lastInitial;
};
